// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-icon {
  background-color: #333742;
  padding: 8px 12px;
  color: rgb(210, 207, 207);
  border-radius: 4px;
  cursor: pointer;
}
.search-icon:hover {
  color: white;
  background-color: #000;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/security-zone/zone-management/zone/zone-mapper-dialog/zone-mapper-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AACF;AAAE;EACE,YAAA;EACA,sBAAA;AAEJ;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAEF","sourcesContent":[".search-icon {\n  background-color: #333742;\n  padding: 8px 12px;\n  color: rgb(210, 207, 207);\n  border-radius: 4px;\n  cursor: pointer;\n  &:hover {\n    color: white;\n    background-color: #000;\n  }\n}\n.search-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
